import {all, call, fork, put, takeEvery, select, putResolve, SagaContext, take} from 'bukku/shared/SagaService';
import actions from './actions';
import AppActions from '../App/actions';
import {get, post} from 'bukku/shared/ApiService';
import {getRequestData} from "./helper/getRequestData";
import {queue} from "./helper/queue";
import {skipRepeatedCall} from "./helper/skipRepeatedCall";
import { requestSagaPullingFn } from '../helper';
import { L } from './reducer';
import { readProductDetailsByChunks } from '../ProductBundle/getBundleItemsDetail';

export function* readListRequestWorker(action) {
    // const { forceMode } = action; // DEPRECATED - to use combimed forceMode
    // Get Request Data
    const { pending, completedIds, readyLists } = yield select(state => state.List.queue);
    const combined =
        pending
            .filter(current => !completedIds.includes(current.requesterId))
            .reduce((accum, current) => ({
                lists: [...accum.lists, ...current.lists],
                params: { ...accum.params, ...current.params },
                requesterIds: [...accum.requesterIds, current.requesterId],
                showSpinner: accum.showSpinner || current.showSpinner,
                forceMode: accum.forceMode || current.forceMode,
            }), {
                lists: [], params: {}, requesterIds: [], showSpinner: false,
            });

    combined.lists = [...new Set(combined.lists)];
    const filteredCombinedList = skipRepeatedCall(combined.lists, readyLists, combined.forceMode);

    // console.log('qq readListRequestWorker-start', {action, pending, completedIds, readyLists, combined});
    // Jye: shouldn't get triggered
    if (combined.requesterIds.length === 0)
        return null;

    let requestData;
    try {
        console.log('aaa readListRequestWorker params', action);
        requestData = yield getRequestData(filteredCombinedList, combined.params);

        let responseData = {};
        if (requestData.lists.length) {
            if (combined.showSpinner)
                yield put({ type: AppActions.APP_START_PULLING });

            const response = yield call(post, '/v2/lists', requestData, new SagaContext(action));
            responseData = yield response.data;
        }

        yield putResolve({
            type: actions.LIST_READ_LISTS_SUCCESS,
            responseData,
            lists: filteredCombinedList,
            params: combined.params,
            requesterIds: combined.requesterIds,
            showSpinner: combined.showSpinner,
        });
    }
    catch (error) {
        // console.log('aaa readListRequestWorker error', {error, action});
        console.error(error);

        yield put({
            type: actions.LIST_READ_LISTS_FAILURE,
            error,
            requesterIds: combined.requesterIds,
            showSpinner: combined.showSpinner,
        });
    }
    finally {
        // console.log('qq readListRequestWorker-end', combined.requesterIds, completedIds);
        // const pullingDepth = yield select(state => state.App.pullingDepth);
        if (combined.showSpinner && requestData.lists.length)
            yield put({type: AppActions.APP_STOP_PULLING});
    }
    return null;
}

export function* readListsRequest() {
    yield queue(50, 500, actions.LIST_READ_LISTS_REQUEST, readListRequestWorker);
}

// Read reconciliations
export function* readReconciliationsRequest() {
    yield takeEvery(actions.LIST_READ_RECONCILIATIONS_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/v2/lists/reconciliations', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.LIST_READ_RECONCILIATIONS_SUCCESS,
                reconciliations: data.items,
            });
        }
        catch (error) {
            yield put({
                type: actions.LIST_READ_RECONCILIATIONS_FAILURE,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}

export function* readProductList() {
    const requestAction = actions.readLists([L.product_list], {}, false, false);
    yield put(requestAction);

    // console.log('qq requestAction', requestAction);
    const { requesterId } = requestAction;
    // console.log('aaa READ_ALL_PRODUCT_AND_PRODUCT_DETAIL_LIST read List Request 1', {requestAction, requesterId});

    // wait for product list to be ready
    let loop = true;
    while (loop) {
        const successAction = yield take(actions.LIST_READ_LISTS_SUCCESS);
        // console.log('aaa READ_ALL_PRODUCT_AND_PRODUCT_DETAIL_LIST read List Request 2', {successAction});
        if (successAction.requesterIds.includes(requesterId))
            loop = false;
    }
}

export function* readAllProductAndProductDetailList() {
    yield takeEvery(actions.READ_ALL_PRODUCT_AND_PRODUCT_DETAIL_LIST, function* (action) {
        yield requestSagaPullingFn(action,
            function* ({ productType }) {
                // console.log('aaa READ_ALL_PRODUCT_AND_PRODUCT_DETAIL_LIST read List Request 0', action);

                yield readProductList();

                const filterFn = product => {
                    switch (productType) {
                        case 'SALE':
                            return product.is_selling && product.type === 'product';
                        case 'PURCHASE':
                            return product.is_buying && product.type === 'product';
                        default:
                            return product.type === 'product';
                    }
                };

                const products = yield select(state => state.List.productList);
                // console.log('aaa READ_ALL_PRODUCT_AND_PRODUCT_DETAIL_LIST read List Request 2', products);
                const productIds = products
                    .filter(filterFn)
                    .map(p => p.id);

                // console.log('aaa READ_ALL_PRODUCT_AND_PRODUCT_DETAIL_LIST read List Request 3', productIds);

                // Full Product Detail List
                const productDetailList = yield readProductDetailsByChunks(productIds, productType);
                yield put({
                    type: actions.LIST_REPLACE_PRODUCT_DETAIL_LIST,
                    productDetailList,
                });
                // console.log('aaa READ_ALL_PRODUCT_AND_PRODUCT_DETAIL_LIST read List Request 4', productDetailList);
            },
        );
    });
}

export default function* rootSaga() {
    yield all([
        fork(readListsRequest),
        fork(readReconciliationsRequest),
        fork(readAllProductAndProductDetailList),
    ]);
}
